// Accesos por perfil (spec docs/superpowers/specs/2026-10-15-accesos-por-perfil-design.md).
//
// apiv2 decide con PERMISOS_POR_PERFIL si los accesos se toman del perfil y lo
// informa en GET /v2/profiles/me/accesos como `aplicar`. Este módulo convierte
// ese estado en el "usuario efectivo" que devuelve el getter auth/getUser:
// todo el código que ya lee user.attributes.* recibe el valor del perfil sin
// cambiar (regla 19 del CLAUDE.md: una sola implementación de permisos).

export const ESTADO_INICIAL = Object.freeze({
  cargado: false,
  aplicar: false,
  perfil: null,
  accesos: {},
})

export function aplicaPerfil(estado) {
  return !!(estado && estado.cargado === true && estado.aplicar === true)
}

export function clavesDeAcceso(estado) {
  return Object.keys((estado && estado.accesos) || {})
}

/**
 * Usuario de la sesión visto a través del perfil.
 * - Sin `aplicar` (variable apagada, estado sin cargar o apiv2 caído): el MISMO
 *   objeto, para no cambiar nada de lo que hoy funciona.
 * - Con `aplicar`: copia cuyas claves de catálogo valen lo del perfil
 *   (ausente = false) y `accesosPorPerfil: true`; el resto de atributos
 *   (consulta_murphy, mando_unico, CAD…) se conserva.
 */
export function usuarioEfectivo(user, estado) {
  if (!user || !aplicaPerfil(estado)) return user
  const accesos = estado.accesos || {}
  const attributes = { ...(user.attributes || {}) }
  Object.keys(accesos).forEach((clave) => {
    attributes[clave] = accesos[clave] === true
  })
  return { ...user, attributes, accesosPorPerfil: true }
}

/** Esquema del diálogo de Perfiles: un separador por grupo y una casilla por acceso. */
export function schemaDeAccesos(catalogo) {
  const schema = {}
  let grupo = null
  const lista = catalogo || []
  lista.forEach((acceso) => {
    if (acceso.grupo !== grupo) {
      grupo = acceso.grupo
      schema[`_grupo_${grupo}`] = {
        label: grupo, type: String, separator: true, optional: true,
      }
    }
    schema[acceso.clave] = { label: acceso.etiqueta, type: Boolean, optional: true }
  })
  return schema
}

/** Cuerpo del PUT: todo el catálogo, booleano estricto, sin separadores ni extras. */
export function valoresDeAccesos(catalogo, item) {
  const valores = item || {}
  return (catalogo || []).reduce((acc, acceso) => {
    acc[acceso.clave] = valores[acceso.clave] === true
    return acc
  }, {})
}

// Separadores que solo existen dentro de la pestaña Módulos.
const SEPARADORES_DE_MODULOS = ['_permissionsSeparator']

/**
 * Esquema de "Editar usuario" cuando los accesos vienen del perfil: sin las
 * casillas de acceso (la pestaña Módulos desaparece porque se queda vacía) y
 * con un aviso justo después del selector de perfil.
 */
export function schemaUsuarioConPerfil(schema, claves) {
  const fuera = new Set([...(claves || []), ...SEPARADORES_DE_MODULOS])
  const resultado = {}
  Object.keys(schema).forEach((key) => {
    if (fuera.has(key)) return
    resultado[key] = schema[key]
    if (key === 'profile') {
      resultado._accesosEnPerfil = {
        label: 'Los accesos a módulos, Murphy y operación se definen en el perfil',
        group: schema[key].group,
        type: String,
        separator: true,
        optional: true,
      }
    }
  })
  return resultado
}

/**
 * preSave de Users.vue re-anida TODO attributeFields: una clave que el
 * formulario ya no muestra llegaría como undefined y BORRARÍA el atributo en
 * Traccar. Los atributos viejos son el respaldo para apagar la variable, así
 * que se rellenan desde el registro original. Muta y devuelve `item`.
 */
export function conservarAccesosOcultos(item, original, claves) {
  const it = item
  const lista = claves || []
  lista.forEach((clave) => {
    if (it[clave] === undefined && original && original[clave] !== undefined) {
      it[clave] = original[clave]
    }
  })
  return it
}
